export const DIRECTORY_SEARCH_RADIUS_MILES = 200
export const DIRECTORY_SEARCH_RADIUS_METERS = DIRECTORY_SEARCH_RADIUS_MILES * 1609

export const COACH_DIRECTORY_ATTRIBUTES_TO_RETRIEVE = [
  'city',
  'state',
  'customSlug',
  'displayName',
  'firstName',
  'lastName',
  'facilities',
  'profilePhoto',
  'bookable',
  'bookingURL',
  'hasIntroVideo',
  'introductionVideoUrl',
  'universalId',
  'memberType',
  'certificationLevel',
  'freeTierLimitsReached',
  'acceptsLeads',
  'hasPlusSubscription',
  'randomInt',
  'bio',
  'startingPrice',
  'serviceTypes',
  'experienceTypes',
  '_geoloc',
  '_rankingInfo',
]
